<template>
    <div class="units">
        <ideo-form-group v-if="isLoaded" :label="$t(label)" :invalid-feedback="formErrors.first('units')" :state="formErrors.state('units')" :disabled="options.enabled === false">
            <ideo-form-select ref="units" name="units" v-model="units" :options="unitsOptions" value-field="id" text-field="name" multiple :size="unitsOptions.length">
                <template #first>
                    <option :value="null"></option>
                </template>
            </ideo-form-select>
        </ideo-form-group>
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { Prop, Watch, Component } from '@/helpers/Decorators';
import Errors from '@/helpers/Errors';
import OrganizationService from '@/modules/core/organization/services/OrganizationService';

@Component({
    name: 'units'
})
export default class Units extends Vue
{
    @Prop({default: true}) public options!: Options;
    @Prop({default: {}}) public formErrors!: Errors;
    @Prop({default: '[[[Wydziały]]]'}) public label!: string;
    @Prop() public modelValue: number[];

    public unitsOptions: Item[] = [];

    public isLoaded: boolean = false;

    public get units(): number[]
    {
        return this.modelValue;
    }

    public set units(value: number[])
    {
        this.$emit('input', value.filter(o => o != null && o != 0));
        this.$emit('update:modelValue', value.filter(o => o != null && o != 0));
    }

    public async created(): Promise<void>
    {
        this.isLoaded = await this.initUnits();
    }

    public async initUnits(): Promise<boolean>
    {
        try
        {
            const result = await OrganizationService.getOptions();

            this.unitsOptions = [];

            const unitsOptions = result.map(m=>
            {
                return { id: m.id, name: m.name };
            });

            this.unitsOptions = this.unitsOptions.concat(unitsOptions);

            /*this.unitsOptions = [{ id: 0, name: '', disabled: false }];

            const unitsOptions = result.map(m=>
            {
                return { id: m.id, name: m.name, disabled: false };
            });

            this.unitsOptions = this.unitsOptions.concat(unitsOptions);

            if (this.options.unavailableUnits && this.options.unavailableUnits.length > 0)
            {
                this.unitsOptions.forEach(element =>
                {
                    element.disabled = this.options.unavailableUnits.some(s=> element.id === s);
                });
            }*/
        }
        catch (ex)
        {
            this.handleException(ex, {
                0: (ex: any) => this.formErrors.push('units', this.$t('[[[Nie udało się pobrać listy wydziałów]]]'))
            });

            return false;
        }

        return true;
    }

    @Watch('units', { deep: true })
    public onInitsChange(value: number[]): void
    {
        value.filter(o => o != null && o != 0);
    }
}

export interface Options
{
    enabled : boolean;
    unavailableUnits: number[];
}

interface Item
{
    id: number;
    name: string;
    // disabled: boolean;
}
</script>
<style lang="scss">
.units{
    .custom-select[multiple], .custom-select[size]:not([size="1"]){
        height:500px;
    }
}
</style>
